import type { Level } from '.';

import { action } from '@play-co/replicant';
import { defineActions } from '../../utils';

export const levelActions = (
  Level: Pick<Level, 'schema' | 'modifiers'>,
  { Inventory }: Level['$DEPENDENCIES'],
) =>
  defineActions<Level>()({
    claimLevelRewards: action((state, _, api) => {
      const now = api.date.now();
      const { getCurrencies } = Inventory.getters(state);

      const oldCurrencies = getCurrencies(now);
      Level.modifiers(state).claimLevelRewards();

      // Send CurrencyGrant event
      api.sendAnalyticsEvents([
        Inventory.ruleset.getCurrencyGrantEvent(
          {
            feature: 'player_level_up',
          },
          {
            old: oldCurrencies,
            new: getCurrencies(now),
          },
        ),
      ]);
    }),
  });
